import { INCODE_SMS_DOC_CAPTURE_SO_NAME_PROPERTY_ID, INCODE_SMS_USE_IDW_TO_SEND_PROPERTY_ID } from "@constants/incode-sms-constants";
import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { FormattedAppliedProfile } from "@idw-types/data/applied-profile/applied-profile";
import { FormattedRpServiceConfigurationProperty } from "@idw-types/data/rp-service-configuration";
import { getPropertyValuesPassedToService } from "@utils/applied-profile-util";

export const getIncodeSmsInfo = (
    properties: Array<FormattedRpServiceConfigurationProperty>,
    appliedProfiles: Array<FormattedAppliedProfile>) => {

    let isIncodeSmsEnabled = false;
    let docCaptureSoNamePropertyValue: string = properties.find(property => property.propertyTypeId === INCODE_SMS_DOC_CAPTURE_SO_NAME_PROPERTY_ID && property.addedToService)?.value;

    const incodeSmsUseIdwToSendProperty = properties.find(property => property.propertyTypeId === INCODE_SMS_USE_IDW_TO_SEND_PROPERTY_ID && property.addedToService);
    if (incodeSmsUseIdwToSendProperty) {
        isIncodeSmsEnabled = isStringTrue(incodeSmsUseIdwToSendProperty.value);
    } else {
        const incodeSmsUseIdwToSendProfilePropertyValue = getPropertyValuesPassedToService(appliedProfiles, INCODE_SMS_USE_IDW_TO_SEND_PROPERTY_ID);
        if (incodeSmsUseIdwToSendProfilePropertyValue) {
            isIncodeSmsEnabled = isStringTrue(incodeSmsUseIdwToSendProfilePropertyValue);
            if(!docCaptureSoNamePropertyValue) {
                docCaptureSoNamePropertyValue = getPropertyValuesPassedToService(appliedProfiles, INCODE_SMS_DOC_CAPTURE_SO_NAME_PROPERTY_ID);
            }
        }
    }

    return {
        isIncodeSmsEnabled,
        docCaptureSoNamePropertyValue
    }
}